<div class="d-block btn-group" role="group">
    <ng-container *ngFor="let option of options; trackBy: trackByValue">
        <input
            [id]="idPrefix + '-' + option.value"
            [name]="name"
            [value]="option.value"
            [checked]="selectedValue === option.value"
            (change)="select(option.value)"
            (blur)="onBlur()"
            [disabled]="disabled"
            autocomplete="off"
            class="btn-check"
            type="radio"
        />
        <label [for]="idPrefix + '-' + option.value" class="btn btn-outline-primary" [translate]="option.label"></label>
    </ng-container>
</div>
